var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"title":_vm.title,"header-color":_vm.headerColor,"width":_vm.width,"content-max-height":_vm.contentMaxHeight}},[_c('base-form',_vm._g(_vm._b({},'base-form',_vm.formConfig,false),_vm.events))],1)}
var staticRenderFns = []

export { render, staticRenderFns }